export interface DraftItem {
  id: string;
  name: string;
  qty: number;
  unit: string;
  priceKop: number;
}

/** Меняем только автоматические названия; удалённые и ручные строки не возвращаем. */
export function retitleDraftItems(current: DraftItem[], before: DraftItem[], after: DraftItem[]): DraftItem[] {
  const previous = new Map(before.map((item) => [item.id, item.name]));
  const next = new Map(after.map((item) => [item.id, item.name]));
  return current.map((item) => previous.get(item.id) === item.name && next.has(item.id)
    ? { ...item, name: next.get(item.id)! }
    : item);
}

/** Ручные изменения работ требуют подтверждения перед сменой группировки. */
export function hasDraftWorkChanges(current: DraftItem[], baseline: DraftItem[]): boolean {
  return baseline.some((original) => {
    const item = current.find((row) => row.id === original.id);
    return !item || item.name !== original.name || item.qty !== original.qty ||
      item.unit !== original.unit || item.priceKop !== original.priceKop;
  });
}

/** Доставку и произвольные строки сохраняем даже при подтверждённой пересборке работ. */
export function regroupDraftItems(current: DraftItem[], before: DraftItem[], after: DraftItem[]): DraftItem[] {
  const workIds = new Set(before.map((item) => item.id));
  const result: DraftItem[] = [];
  let inserted = false;
  for (const item of current) {
    if (workIds.has(item.id)) {
      if (!inserted) { result.push(...after); inserted = true; }
    } else result.push(item);
  }
  if (!inserted) result.unshift(...after);
  const delivery = result.findIndex((item) => item.id === 'clinic-delivery');
  if (delivery >= 0) {
    const [item] = result.splice(delivery, 1);
    result.splice(Math.min(1, result.length), 0, item!);
  }
  return result;
}
